// @generated

import { decodeHex } from "../common/hex.js"

export default decodeHex(
"\
0061736d0100000001230660000060017b017b60027f7f0060047f7f7f7f0060\
017f017e60067f7f7f7f7f7f0002120106787868617368066d656d6f72790200\
0103070600010203040506a3010b7f0041080b7f0041c0020b7e00428795afaf\
98b6de9b9e7f0b7b00fd0c87caeb85b179379e87caeb85b179379e0b7e0042cf\
d6d3bed2c7abd9420b7b00fd0c4febd4273daeb2c24febd4273daeb2c20b7e00\
42f9f3ddf199f699ab160b7e0042e3dcca95fccef2f5857f0b7e0042c5cfd9b2\
f1e5baea270b7b00fd0cd6b5c0adee27ea604febd4273daeb2c20b7b00fd0c00\
000000000000007935147a4e86c8610b073e060a6d61785f726f756e64730300\
08667265655f6d656d030108696e69745f6d6f64000005726573657400020675\
706461746500030664696765737400050ace05067b03017f017b017f03402000\
23092001fdce01fd0b04002000230a2001fdce01fd0b0410200041206a210020\
01fd0c01000000000000000100000000000000fdce012101200241016a220223\
00470d000b418002210041002102034020002002ad23087c370300200041086a\
2100200241016a22022300470d000b0b12002000411ffdcb0120004121fdcd01\
fd500b0f0020014100200041206cfc0a00000b7f03027f027b017f03402002fd\
0004002305fdd50121062002fd0004102305fdd5012107410021042001210803\
4020082008fd0004002006fdce0110012303fdd501fd0b040020082008fd0004\
102007fdce0110012303fdd501fd0b0410200841206a2108200441016a220420\
00470d000b200241206a22022003490d000b0b870101027b2000fd0004002101\
2000fd00041021022001fd1d004201892001fd1d014207892002fd1d00420c89\
2002fd1d014212897c7c7c20012305fdd50110012303fdd501210120022305fd\
d50110012303fdd50121022001fd1d008523027e23077c2001fd1d018523027e\
23077c2002fd1d008523027e23077c2002fd1d018523027e23077c0ba3020302\
7f017e027f200241204e0440200521070340200720011004370300200741086a\
2107200141206a2101200641016a22062000470d000b05200541800220004108\
6cfc0a00000b2005210741002106034020072903002002ad7c21082003210903\
400240200941086a220a20044b0d00200929030023047e421f8923027e200885\
421b8923027e23077c2108200a21090c010b0b0240200941046a220a20044b0d\
00200935020023027e20088542178923047e23067c2108200a21090b03400240\
200920044f0d00200931000023087e200885420b8923027e2108200941016a21\
090c010b0b200820084221888523047e22082008421d888523067e2208200842\
208885210820072008370300200741086a2107200641016a22062000470d000b\
0b\
",
)
